








































import {Prop} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component, Vue} from '@/shared/component';
import {ResultType} from '@/shared/xhttp';
import {Token} from '@/models';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import TokenRight from '@/components/Input/TokenRight.vue';

import storeToken from '@/stores/modules/token';

@Component({
	components: {
		TokenRight,
		CrudList,
		TableHead,
		TableCell,
	}
})
export default class CrudTokenList extends Vue {
	
	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	
	private storeToken = storeToken;
}
